<div class="announcement">
  <app-container>
    <app-bread-crumbs />

    <h4 class="title">{{ page?.translation?.data?.title }}</h4>
  </app-container>
  <app-announcement-list></app-announcement-list>
</div>
